// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("C:\\Users\\KwS\\dev\\site\\src\\pages\\404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("C:\\Users\\KwS\\dev\\site\\src\\pages\\index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-time-js": () => import("C:\\Users\\KwS\\dev\\site\\src\\pages\\time.js" /* webpackChunkName: "component---src-pages-time-js" */)
}

